import { render, staticRenderFns } from "./Categories.vue?vue&type=template&id=4970bc0c"
import script from "./Categories.js?vue&type=script&lang=js&external"
export * from "./Categories.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports